// Expéditeur d'un envoi (`message.user`) : un utilisateur (users/{uid}) ou, pour un envoi déposé
// par l'API, un compte de service (service_accounts/{id}) — décisions 01-02/10/2026.

export function isServiceAccountRef(ref) {
  return Boolean(ref && ref.parent && ref.parent.id === "service_accounts");
}

// Libellé « Déclenché par » à partir de la référence et du document de l'expéditeur
export function senderLabel(userRef, sentBy) {
  if (!sentBy) return "";
  if (isServiceAccountRef(userRef)) return `Compte de service : ${sentBy.name} (API)`;
  return `${sentBy.last_name} ${sentBy.first_name} (${sentBy.email})`;
}
